import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { environment } from '../environment';
import { Http, Response, Headers } from '@angular/http';
import { News } from '../models/news';

@Component({
  selector: 'dev-updates',
  templateUrl: './updates.component.html'
})

export class UpdatesComponent implements OnInit {
	news: News;
	updates = 0;
	headerHeight: any;
	headerAlign: any;
	title: any;
	subtitle: any;
	header: any;

  	constructor(private http : Http,
  				private sanitizer: DomSanitizer ) { }


  	getNews(): Promise<News> {
		return this.http
			.get(`${environment.baseUrl}/updates/`,
			{headers: this.getHeaders()})
			.toPromise()
			.then(mapNews)
			.catch((err) => {
				console.log(err);
			})
  	}


  	private getHeaders() {
		let headers = new Headers();
		headers.append('Accept', 'application/json');
		return headers;
	}



  	/* On with the show */
	ngOnInit() {

		this.title = 'Welcome to Identity';
		this.subtitle = 'Collect your gifts by logging into your account.';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/header-shop.jpg")' );
		this.headerHeight = '400px';
		Promise.resolve(this.getNews()).then(posts =>
			this.news = posts
		);
	}

}

	/**
	* 		Managing news items
	**/

	function mapNews(response?:Response): News {
		let res = response.json().map(toNewsFeed);
		return res;
	}

	function toNewsFeed(r?:any): News {
		let newsItems = <News>({
			tid: r.tid,
			title: r.title,
			title_seo: r.title_seo,
			start_date: r.start_date,
			starter_id: r.starter_id,
			starter_name: r.starter_name,
			topic_firstpost: r.topic_firstpost,
			post: r.post,
			url: r.url,
			author_url: r.author_url,
			comments_url: r.comments_url
		});
		return newsItems;
	}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/updates/updates.component.ts